/* ============================================================
   SUIS "PHOTO POST" TIKTOK — Control Panel (2026-11-04)

   HIDUP → robot post GAMBAR card (gambar utama + tambahan) melalui tab
   Photos TikTok Studio, satu post setiap card. MATI (lalai) → video setiap
   set seperti biasa. Nilai + simpanan: utils/jenisPostTiktok.js (per-browser),
   ditulis HANYA dalam pengendali klik. Baris suis dilukis oleh `barisSuis`
   (barisSuisV39 App.jsx) supaya rupa kekal satu takrifan.
   ============================================================ */
import { useState } from 'react';
import { bacaJenisPostTiktok, tulisJenisPostTiktok } from '../utils/jenisPostTiktok';

export default function JenisPostTiktokV39({ t, barisSuis }) {
  const [jenis, setJenis] = useState(() => bacaJenisPostTiktok());
  const [gagalSimpan, setGagalSimpan] = useState(false);
  const gambar = jenis === 'gambar';

  const tukar = () => {
    const baru = gambar ? 'video' : 'gambar';
    setJenis(baru);
    /* Storan browser ditutup → pilihan tidak sampai ke robot. Beritahu, jangan senyap. */
    setGagalSimpan(!tulisJenisPostTiktok(baru));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 15, paddingBottom: 16, borderBottom: '1px solid var(--s-line)', marginBottom: 16 }}>
      <p className="s-sect__title">{t('workspace.page.sect.ttJenisPost', 'Post Type')}</p>
      {barisSuis({
        kunci: 'ttjenispost', label: 'Photo post',
        nota: gambar
          ? t('workspace.ttJenisPost.gambarOn', 'Robot memuat naik gambar card (gambar utama + gambar tambahan) sebagai satu post gambar TikTok bagi setiap card. Video tidak dipost.')
          : t('workspace.ttJenisPost.gambarOff', 'Robot memuat naik video setiap set yang dipilih.'),
        on: gambar, onChange: tukar,
      })}
      {gagalSimpan && (
        <p className="s-hint" role="alert">{t('workspace.ttChecks.gagalSimpan', 'Pilihan ini tidak dapat disimpan dalam browser ini.')}</p>
      )}
    </div>
  );
}
